import { combineEpics } from 'redux-observable';
import * as steps from 'common/steps';
import * as fileUploadActions from './fileUploadActions';

import { createCompleteStepEpic } from 'common/stepEpicUtil';

export default combineEpics(
  createCompleteStepEpic(fileUploadActions.COMPLETE_STEP, steps.FILE_UPLOAD),
);



// WEBPACK FOOTER //
// ./src/file-upload/fileUploadEpic.js